import { Action, createReducer, on } from '@ngrx/store';
import { ShoppingCartPhysicalDeliveryFormData } from '@rd/form-builder/types/shopping-cart-delivery-form-data.type';
import { HttpError } from '@rd/types';
import { Order } from '@rd/types/order.type';
import { IntentionalUndefined } from 'global-types';
import {
  UpdateDeliveryDetails,
  UpdateDeliveryDetailsFail,
  UpdateDeliveryDetailsSuccess,
} from '../actions/delivery-details.actions';

export interface DeliveryDetailsState {
  error: HttpError | null;
  loading: boolean;
}

const initialState: DeliveryDetailsState = {
  error: null,
  loading: false,
};

const featureReducer = createReducer(
  initialState,
  on(
    UpdateDeliveryDetails,
    (
      state: DeliveryDetailsState,
      payload: {
        deliveryDetails: Partial<ShoppingCartPhysicalDeliveryFormData>;
      },
    ) => {
      const { deliveryDetails } = payload;
      return {
        ...state,
        deliveryDetails,
        error: null,
        loading: true,
      };
    },
  ),
  on(
    UpdateDeliveryDetailsFail,
    (state: DeliveryDetailsState, payload: HttpError) => {
      const { ...httpError } = payload;
      return {
        ...state,
        error: httpError,
        loading: false,
      };
    },
  ),
  on(
    UpdateDeliveryDetailsSuccess,
    (
      state: DeliveryDetailsState,
      payload: {
        order: Order;
      },
    ) => {
      return {
        ...state,
        error: null,
        loading: false,
      };
    },
  ),
);

export function deliveryDetailsReducer(
  state: DeliveryDetailsState | IntentionalUndefined,
  action: Action,
): DeliveryDetailsState {
  return featureReducer(state, action);
}
